import React from 'react';
import styled from 'styled-components';

import TwitterIcon from './Social/Twitter';
import FacebookIcon from './Social/Facebook';
import InstagramIcon from './Social/Instagram';
import LinkedInIcon from './Social/LinkedIn';
import GithubIcon from './Social/Github';

import { social } from '../helpers/links';

const SocialContainer = styled.div`
  display: flex;

  a {
    margin-right: 1.3rem;
  }
`;

const Social = () => (
  <SocialContainer>
    <a
      href={social.twitter}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Find Small Planet on Twitter"
    >
      <TwitterIcon />
    </a>
    <a
      href={social.facebook}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Find Small Planet on Facebook"
    >
      <FacebookIcon />
    </a>
    <a
      href={social.instagram}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Find Small Planet on Instagram"
    >
      <InstagramIcon />
    </a>
    <a
      href={social.linkedin}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Find Small Planet on LinkedIn"
    >
      <LinkedInIcon />
    </a>
    <a
      href={social.github}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Find Small Planet on GitHub"
    >
      <GithubIcon />
    </a>
  </SocialContainer>
);

export default Social;
